module.exports = __webpack_public_path__ + "static/media/cov_bys.664c1d6a.png";